module.exports = __webpack_public_path__ + "img/landscape_1-lazy.82f79608.jpg";